import { hasPermission, useMyPermissions } from "../lib/permissions.js";
import { PERMISSIONS } from "../lib/permissionKeys.js";
import OtelMirrorSettings from "../components/OtelMirrorSettings.jsx";
import ScopedAdminPage from "../components/ScopedAdminPage.jsx";
import { EndpointConfigurationSection } from "./SettingsPage.jsx";
import BrowserCaptureSettings from "../components/BrowserCaptureSettings.jsx";

export default function EndpointConfigurationPage({ viewDef }) {
    const caps = useMyPermissions();
    const canConfigureOrigin = hasPermission(caps, PERMISSIONS.TENANT_CONFIG_WRITE);
    return (
        <ScopedAdminPage
            title={viewDef?.label ?? "Configuration"}
            scope="All endpoints"
        >
            {canConfigureOrigin ? <><EndpointConfigurationSection /><BrowserCaptureSettings /></> : null}
            <OtelMirrorSettings />
        </ScopedAdminPage>
    );
}
